// Registers ScrollTrigger and exposes gsap globally for template usage if desired.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

export { gsap, ScrollTrigger };